import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import CommentsFormComponent from '../../../../components/CommentsFormComponent/CommentsFormComponent'
import { WebinarPanelComponent } from '../../../WebinarSidebarFeature/components'
import {
  getAudienceName,
  hasAudienceName,
} from '../../../../../Chat/blocs/useAudienceName'
import { useAskAudienceName } from '../../../../../Chat/components/AskAudienceName/AskAudienceNameModal'

import './WebinarQuestionsCardComponent.scss'

const getFormStyles = (styles) => {
  // use secondary button styles for the button
  return {
    ...styles,
    buttonStyle: styles.buttonStyle,
  }
}

const WebinarQuestionsCardComponent = (props) => {
  const [isQuestionSent, setIsQuestionSent] = useState(false)

  const openAskAudienceNameModal = useAskAudienceName()

  const { styles, onAskQuestion } = props

  if (isQuestionSent) {
    return (
      <div className="webinar-questions-card-component">
        <WebinarPanelComponent>
          <span className="question-sent-message">
            <FormattedMessage defaultMessage="Question was sent and can only be seen by the hosts and speakers." />
          </span>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <div
            className="ask-new-one"
            role="button"
            onClick={() => setIsQuestionSent(false)}
            onKeyDown={(e) =>
              e.key === 'Enter' &&
              e.shiftKey === false &&
              setIsQuestionSent(false)
            }
            tabIndex={0}
          >
            <FormattedMessage defaultMessage="Ask another question" />
          </div>
        </WebinarPanelComponent>
      </div>
    )
  }

  const onAddComment = async (formValues, { resolve, reject }) => {
    if (!hasAudienceName()) {
      const finished = await openAskAudienceNameModal()
      if (!finished) {
        resolve()
        return
      }
    }

    const handleResolve = () => {
      setIsQuestionSent(true)
      resolve()
    }

    onAskQuestion(
      { ...formValues, name: getAudienceName() },
      { resolve: handleResolve, reject }
    )
  }

  return (
    <div className="webinar-questions-card-component">
      <CommentsFormComponent
        form="audience-presenter-questions-form"
        onSubmit={onAddComment}
        styles={getFormStyles(styles)}
        hasButtonIcon={false}
        buttonText={intl.formatMessage({ defaultMessage: 'Ask question' })}
      />
    </div>
  )
}

WebinarQuestionsCardComponent.propTypes = {
  styles: PropTypes.shape({
    inputStyle: PropTypes.object,
    secondaryButtonStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
  }),
  onAskQuestion: PropTypes.func,
}

export default WebinarQuestionsCardComponent
